import { render, staticRenderFns } from "./PvzModal.vue?vue&type=template&id=5d928155"
import script from "./PvzModal.vue?vue&type=script&lang=js"
export * from "./PvzModal.vue?vue&type=script&lang=js"
import style0 from "./PvzModal.vue?vue&type=style&index=0&id=5d928155&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports